import { useEffect } from 'react';
import { setCountryCode } from '../services/api';
import { useQuery } from './useQuery';

export const useCountryCodeInterceptor = () => {
  const query = useQuery();
  const urlCountryCode = query.get('countryCode');
  const urlCountry = query.get('country');

  const countryCode = urlCountryCode || urlCountry || 'AR';

  useEffect(() => {
    setCountryCode(countryCode);
  }, [countryCode]);

  return countryCode;
};
